import { requestApiV2 } from '@library'
import { CommonList } from '@types'
import {
  AIQualityCheckPlanDetailFilter,
  AIQualityCheckPlanDetailItem,
  AIQualityCheckPlanListFilter,
  AIQualityCheckPlanListItem,
  AIQualityCheckTaskListItem,
  AIQualityCheckTaskDetailItem,
  AIQualityCheckPlanPromptFilter,
  AIQualityCheckPlanVersionItem,
  AIQualityCheckPlanPromptTemplateItem,
  AIQualityCheckTaskListFilter,
  AIQualityCheckTaskCreateFilter,
  QCDashboardOverview,
  QCDashboardFilter,
} from 'src/types/ai-quality-check'

// 获取质检方案详情
export function getAIQualityCheckPlanDetail (filter: AIQualityCheckPlanDetailFilter) {
  return requestApiV2<CommonList<AIQualityCheckPlanDetailItem>>('/trpc.tcc.tcc_main.AIQualityCheck/GetAIQualityCheckPlanDetail', filter)
}

export function saveAIQualityCheckPlan (params: AIQualityCheckPlanDetailItem) {
  return requestApiV2<{ planId: number }>('/trpc.tcc.tcc_main.AIQualityCheck/SaveAIQualityCheckPlan', params)
}

export function submitSchemeOptimize (params: { planId: number }) {
  return requestApiV2<{}>('/trpc.tcc.tcc_main.AIQualityCheck/SubmitOptimize', params)
}

// 获取质检方案列表
export function getAIQualityCheckPlanList (params: AIQualityCheckPlanListFilter) {
  return requestApiV2<CommonList<AIQualityCheckPlanListItem>>('/trpc.tcc.tcc_main.AIQualityCheck/GetAIQualityCheckPlanList', params)
}

// 获取质检方案版本列表
export function getAIQualityCheckPlanVersionList (params: { planId: number }) {
  return requestApiV2<CommonList<AIQualityCheckPlanVersionItem>>('/trpc.tcc.tcc_main.AIQualityCheck/GetAIQualityCheckPlanVersionList', params)
}

// 获取prompt
export function getAIQualityCheckPlanPrompt (params: { planId: number, planVersionId?: number }) {
  return requestApiV2<{ prompt: string }>('/trpc.tcc.tcc_main.AIQualityCheck/GetQualityCheckPlanPrompt', params)
}

// 获取prompt模版
export function getAIQualityCheckPlanPromptTemplate (params: { planType?: number }) {
  return requestApiV2<{ templates: AIQualityCheckPlanPromptTemplateItem[] }>('/trpc.tcc.tcc_main.AIQualityCheck/GetQualityCheckPlanPromptTemplate', params)
}

// 保存prompt和完成调优
export function saveAIQualityCheckPlanPrompt (params: AIQualityCheckPlanPromptFilter) {
  return requestApiV2<{}>('/trpc.tcc.tcc_main.AIQualityCheck/SaveQualityCheckPlanPrompt', params)
}

export function copyAIQualityCheckPlan (params: { planId: number }) {
  return requestApiV2<{}>('/trpc.tcc.tcc_main.AIQualityCheck/CopyAIQualityCheckPlan', params)
}

export function deleteAIQualityCheckPlan (params: { planId: number }) {
  return requestApiV2<{}>('/trpc.tcc.tcc_main.AIQualityCheck/DeleteAIQualityCheckPlan', params)
}

// 获取质检任务列表
export function getQualityCheckTaskList (params: AIQualityCheckTaskListFilter) {
  return requestApiV2<CommonList<AIQualityCheckTaskListItem>>('/trpc.tcc.tcc_main.AIQualityCheck/GetTaskList', params)
}

// 更新质检任务状态
export function updateQualityCheckTaskStatus (params: { taskId: number, status: number }) {
  return requestApiV2('/trpc.tcc.tcc_main.AIQualityCheck/UpdateTask', params)
}

// 获取质检任务数据范围支持的字段
export function getQualityCheckTaskDataSupportFields (params) {
  return requestApiV2('/trpc.tcc.tcc_main.AIQualityCheck/GetTaskDataScopeSupportFields', params)
}

// 创建质检任务
export function createQualityCheckTask (params: AIQualityCheckTaskCreateFilter) {
  return requestApiV2('/trpc.tcc.tcc_main.AIQualityCheck/CreateTask', params)
}

// 绑定agentkey
export function bindAgentKey (params: { planId: number, agentKey: string }) {
  return requestApiV2<{}>('/trpc.tcc.tcc_main.AIQualityCheck/BindAgentKey', params)
}

// 删除质检任务
export function deleteQualityCheckTask (params: { taskId: number }) {
  return requestApiV2<{}>('/trpc.tcc.tcc_main.AIQualityCheck/DeleteTask', params)
}

// 获取质检看板概览数据
export function getQCDashboardOverview (payload?: QCDashboardFilter) {
  return requestApiV2<QCDashboardOverview>('/trpc.tcc.tcc_main.AIQualityCheck/GetQCDashboardOverview', payload)
}
